import { useEffect, useState } from 'react';

import { Icon } from 'components/Icons';

import * as S from './CheckMark.styles';

type CheckMarkProps = {
  isChecked: boolean;
  onClick?: () => void;
  disabled?: boolean;
};

const defaultProps: Partial<CheckMarkProps> = {
  onClick: undefined,
};

export function CheckMark(props: CheckMarkProps): React.ReactElement {
  const { isChecked, onClick, disabled } = { ...defaultProps, ...props };
  const [checked, checkedSet] = useState<boolean>(isChecked);

  useEffect(() => {
    checkedSet(isChecked);
  }, [isChecked]);

  const cursor = disabled ? 'not-allowed' : 'pointer';
  const icon = checked ? 'FiCheck' : 'FiX';
  const isCheckedBackground = checked ? '#37B34A' : '#FFF';
  const iconBackground = disabled ? '#E2E2E2' : isCheckedBackground;

  return (
    <S.Container disabled={disabled} checked={checked} background={iconBackground}>
      <Icon
        cursor={cursor}
        onClick={() => {
          if (!disabled) {
            if (onClick) onClick();
            checkedSet(!checked);
          }
        }}
        name={icon}
        color={!disabled ? 'white' : 'transparent'}
      />
    </S.Container>
  );
}
